<hslayers [id]="id"></hslayers>